import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import {createTerms, updateTerms } from '../../../Utility/Api';
import { WarehouseContext } from '../../../Utility/UserContext';
import { shop_id } from '../../../Utility/function';


const EditTerms = ({ showModal, setShowModal, fetchTerms, selectedTerm, AddorEdit, formData, setFormData }) => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const { shopItem } = useContext(WarehouseContext);


    useEffect(() => {
        if (!AddorEdit && selectedTerm) {
            setFormData({
                shop_id: shopItem?.shop_id  || '',
                terms: selectedTerm.terms || '',
                status: selectedTerm.status || '1',
                remark: selectedTerm.remark || '',
                type: selectedTerm.type || 'Purchase'
            });
        }
    }, [selectedTerm, AddorEdit]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.terms) newErrors.terms = 'terms and conditions is required';
        if (!formData.type) newErrors.type = 'type for is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        try {
            const payload = {
                shop_id: shopItem?.shop_id || "0",
                terms: formData.terms,
                status: formData.status,
                remark: formData.remark,
                type: formData.type
            };

            if (AddorEdit) {
                await createTerms(payload);
                toast.success('Terms created successfully');
            } else {
                await updateTerms(selectedTerm.id, payload);
                toast.success('Terms updated successfully');
            }

            setShowModal(false);
            fetchTerms();
        } catch (error) {
            console.error('Error saving terms:', error);
            toast.error(error.message || 'Error saving terms');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    

    return (
        <div className={`modal fade ${showModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{AddorEdit ? 'Add New Terms' : 'Edit Terms'}</h5>
                        <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                       
                            <div className="mb-3">
                                <label className="form-label">Invoice Type <span className="text-danger">*</span></label>
                                <select
                                    className={`form-select ${errors.type ? 'is-invalid' : ''}`}
                                    name="type"
                                    value={formData.type}
                                    onChange={handleChange}
                                >
                                    <option value="Purchase">Purchase</option>
                                    <option value="Quotation">Quotation</option>
                                    <option value="Sales">Sales</option>
                                </select>
                                {/* {errors.type && <div className="invalid-feedback">{errors.type}</div>} */}
                            </div>


                            <div className="mb-3">
                            <label className="form-label">Terms & conditions <span className="text-danger">*</span></label>
                                <textarea
                                    className={`form-control ${errors.terms ? 'is-invalid' : ''}`}
                                    rows="4"
                                    name="terms"
                                    value={formData.terms}
                                    onChange={handleChange}
                                ></textarea>
                                {errors.terms && <div className="invalid-feedback">{errors.terms}</div>}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Remark</label>
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    name="remark"
                                    value={formData.remark}
                                    onChange={handleChange}
                                ></textarea>
                            </div>


                            {/* {!AddorEdit && (
                                <div className="mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            )} */}

                            <div className="d-flex justify-content-end gap-2">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Saving...' : 'Save '}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTerms;